import connect from "Shared/connect";
import { setAccountBoxOpen, setLoginUrl, } from "SiteLayout/Header/AccountBox/action-creators";
const LoginContainer = ({ children, setAccountBoxOpen, setLoginUrl, isLoggedIn, signUpUrl, }) => children({
    setAccountBoxOpen,
    setLoginUrl,
    isLoggedIn,
    signUpUrl,
});
export default connect((state) => ({
    isLoggedIn: !!state.currentUser && state.currentUser.isLoggedIn,
    signUpUrl: state.appShellData.siteSettings.signUpPage.url,
}), (dispatch) => ({
    setAccountBoxOpen: () => dispatch(setAccountBoxOpen()),
    setLoginUrl: () => dispatch(setLoginUrl),
}))(LoginContainer);
